export default class State {
    static get id() {
        throw new Error('State needs to implement an id getter');
    }

    static performAutomatically() {
        return null;
    }
}
